export default (sellerId: number) => `/smb-profile/profile/${sellerId}/website/redirect`;
